// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation, Link } from "react-router-dom";
// import Header from "../Header";
// import { Table } from "antd";
// import { UpdateCourseDetails } from "../../api/aws-api";
// import { ConstructorEventPost } from "../../Event/event";
// import { ClassicSpinner } from "react-spinners-kit";
// import { notifyError, notifySuccess } from "../../Common/CommonFunction";

// const ActivityManagement = () => {
//   const [loading, setLoading] = useState(false);
//   const [ActivityEditMenu, setActivityEditMenu] = useState(false);
//   const [SaveToCloud, setSaveToCloud] = useState(false);
//   const [data, setData] = useState([]);

//   const [DisplayData, setDisplayData] = useState([]);
//   const [Description, setDescription] = useState("");
//   const [Description_Head, setDescription_Head] = useState("");
//   const [Lectures, setLectures] = useState("");
//   const [ModuleName, setModuleName] = useState("");
//   const [TotalDurationInMinutes, setTotalDurationInMinutes] = useState("");
//   const [ActivityResource, setActivityResource] = useState([]);

//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     const { data } = location.state ? location.state : [];
//     if (data) {
//       setData(data);
//       setDisplayData(data["modules"] ? data["modules"] : []);
//     }
//   }, []);

//   const EraseDataFromState = () => {
//     setDescription("");
//     setDescription_Head("");
//     setLectures("");
//     setModuleName("");
//     setTotalDurationInMinutes("");
//     setActivityResource([]);
//   };

//   const setDataToEditTab = (data) => {
//     setDescription(data.description);
//     setDescription_Head(data.description_head);
//     setLectures(data.Lectures);
//     setModuleName(data.module_name);
//     setTotalDurationInMinutes(data.TotalDurationInMinutes);
//     setActivityResource(data.resource);
//     setActivityEditMenu(true);
//   };

//   const columns = [
//     {
//       title: "Module Name",
//       dataIndex: "module_name",
//       sorter: (a, b) => a.module_name.length - b.module_name.length,
//       render: (text, record) => (
//         <Link onClick={() => setDataToEditTab(record)}>{text}</Link>
//       ),
//     },
//     {
//       title: "Description Head",
//       dataIndex: "description_head",
//       sorter: (a, b) => a.description_head.length - b.description_head.length,
//     },
//     {
//       title: "Resource Count",
//       dataIndex: "resource",
//       render: (text) => <div>{text.length}</div>,
//     },
//     {
//       title: "Duration in Minutes",
//       dataIndex: "TotalDurationInMinutes",
//     },
//     {
//       title: "Activities",
//       dataIndex: "module_name",
//       render: (text, record) => (
//         <div>
//           <Link
//             to="/codomo/admin/subactivitymanagement"
//             state={{ fulldata: data, data: record }}
//           >
//             <iconify-icon
//               icon="icon-park-outline:activity-source"
//               style={{ color: "blue", fontSize: "1.8em", marginLeft: "20px" }}
//             ></iconify-icon>
//           </Link>
//           <iconify-icon
//             icon="line-md:remove"
//             style={{ color: "red", fontSize: "1.8em", marginLeft: "20px" }}
//             onClick={() => RemoveItemFromdata(text)}
//           />
//         </div>
//       ),
//     },
//   ];

//   const UpdateDataInState = () => {
//     // Convert numeric fields to strings for validation
//     const trimmedModuleName = ModuleName.trim();
//     const trimmedDescriptionHead = Description_Head.trim();
//     const trimmedDescription = Description.trim();
//     const trimmedLectures = Lectures.toString().trim();
//     const trimmedTotalDuration = TotalDurationInMinutes.toString().trim();

//     if (
//       !trimmedModuleName ||
//       !trimmedDescriptionHead ||
//       !trimmedDescription ||
//       !trimmedLectures ||
//       !trimmedTotalDuration
//     ) {
//       notifyError("Please fill all required fields before saving");
//       return;
//     }

//     const temp = {
//       module_name: trimmedModuleName,
//       description_head: trimmedDescriptionHead,
//       description: trimmedDescription,
//       Lectures: Number(trimmedLectures),
//       TotalDurationInMinutes: Number(trimmedTotalDuration),
//       resource: ActivityResource,
//     };

//     const Repetation = DisplayData.filter(
//       (item) => item.module_name !== trimmedModuleName
//     );
//     setDisplayData([...Repetation, temp]);
//     setActivityEditMenu(false);
//     setSaveToCloud(true);
//   };

//   const RemoveItemFromdata = (moduleNameOfItem) => {
//     const Repetation = DisplayData.filter(
//       (item) => item.module_name !== moduleNameOfItem
//     );
//     setDisplayData(Repetation);
//     setSaveToCloud(true);
//   };

//   const UpdateUserDataToCloud = async () => {
//     setLoading(true);
//     let temp = data;
//     temp["modules"] = DisplayData;

//     const responsedata = await ConstructorEventPost(UpdateCourseDetails, temp);
//     if (responsedata === "course_updated") {
//       notifySuccess("Activity Updated");
//       navigate("/codomo/admin/activitymanagement");
//     } else {
//       notifyError("Something Gone Wrong");
//     }
//     setLoading(false);
//   };

//   if (data?.course_id) {
//     localStorage.setItem("course_id_1", data.course_id);
//   }

//   return (
//     <>
//       <Header />
//       {loading ? (
//         <div className="spinner">
//           <div className="spinner-wrapper">
//             <ClassicSpinner size={50} color="black" loading={loading} />
//           </div>
//         </div>
//       ) : (
//         <div className="nav-tab-wrapper tabs section-padding">
//           <div className="container">
//             <div className="grid grid-cols-12 gap-[30px]">
//               <div className="xl:col-span-5 lg:col-span-6 col-span-12">
//                 <div className="mini-title">
//                   Activity Management
//                   {SaveToCloud && (
//                     <div
//                       className="small-btn-saveDataToCloud ml-4"
//                       onClick={UpdateUserDataToCloud}
//                     >
//                       <iconify-icon
//                         icon="tabler:cloud-up"
//                         style={{ fontSize: "1em" }}
//                       />
//                       Save Changes To Cloud
//                     </div>
//                   )}
//                 </div>
//                 <div
//                   className="small-btn mt-4"
//                   onClick={() => (EraseDataFromState(), setActivityEditMenu(true))}
//                 >
//                   <iconify-icon
//                     icon="typcn:plus"
//                     style={{ fontSize: "1em" }}
//                   ></iconify-icon>{" "}
//                   Create New Activity
//                 </div>

//                 {ActivityEditMenu && (
//                   <div className="bg-white shadow-box7 p-8 rounded-md mt-8">
//                     <div className="input-container mt-8">
//                       <input
//                         type="text"
//                         className="from-control"
//                         value={ModuleName}
//                         onChange={(e) => setModuleName(e.target.value)}
//                       />
//                       <span
//                         className={`input-placeholder ${
//                           ModuleName && "active"
//                         }`}
//                       >
//                         Module Name *
//                       </span>
//                     </div>
//                     <div className="input-container mt-8">
//                       <input
//                         type="text"
//                         className="from-control"
//                         value={Description_Head}
//                         onChange={(e) => setDescription_Head(e.target.value)}
//                       />
//                       <span
//                         className={`input-placeholder ${
//                           Description_Head && "active"
//                         }`}
//                       >
//                         Description Head *
//                       </span>
//                     </div>
//                     <div className="input-container mt-8">
//                       <input
//                         type="text"
//                         className="from-control"
//                         value={Description}
//                         onChange={(e) => setDescription(e.target.value)}
//                       />
//                       <span
//                         className={`input-placeholder ${Description && "active"}`}
//                       >
//                         Description *
//                       </span>
//                     </div>
//                     <div className="input-container mt-8">
//                       <input
//                         type="number"
//                         className="from-control"
//                         value={TotalDurationInMinutes}
//                         onChange={(e) => setTotalDurationInMinutes(e.target.value)}
//                       />
//                       <span
//                         className={`input-placeholder ${
//                           TotalDurationInMinutes && "active"
//                         }`}
//                       >
//                         Total Duration In Minutes *
//                       </span>
//                     </div>
//                     <div className="input-container mt-8">
//                       <input
//                         type="number"
//                         className="from-control"
//                         value={Lectures}
//                         onChange={(e) => setLectures(e.target.value)}
//                       />
//                       <span
//                         className={`input-placeholder ${Lectures && "active"}`}
//                       >
//                         Lectures *
//                       </span>
//                     </div>
//                     <button
//                       className="btn btn-black mt-4 mr-4"
//                       onClick={UpdateDataInState}
//                       disabled={
//                         !ModuleName.trim() ||
//                         !Description_Head.trim() ||
//                         !Description.trim() ||
//                         !TotalDurationInMinutes.toString().trim() ||
//                         !Lectures.toString().trim()
//                       }
//                       style={{
//                         opacity:
//                           !ModuleName.trim() ||
//                           !Description_Head.trim() ||
//                           !Description.trim() ||
//                           !TotalDurationInMinutes.toString().trim() ||
//                           !Lectures.toString().trim()
//                             ? 0.5
//                             : 1,
//                         cursor:
//                           !ModuleName.trim() ||
//                           !Description_Head.trim() ||
//                           !Description.trim() ||
//                           !TotalDurationInMinutes.toString().trim() ||
//                           !Lectures.toString().trim()
//                             ? "not-allowed"
//                             : "pointer",
//                       }}
//                     >
//                       Save
//                     </button>
//                   </div>
//                 )}
//               </div>

//               <div className="xl:col-span-7 lg:col-span-6 col-span-12">
//                 <div className="bg-white shadow-box7 p-8 rounded-md">
//                   <div className="from-control mb-4">
//                     Total Activity : {DisplayData && DisplayData.length}
//                   </div>
//                   <Table
//                     columns={columns}
//                     dataSource={DisplayData}
//                     pagination={DisplayData.length > 9}
//                     rowKey={(record) => record.module_name}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ActivityManagement;




































import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import Header from "../Header";
import { Table } from "antd";
import { UpdateCourseDetails } from "../../api/aws-api";
import { ConstructorEventPost } from "../../Event/event";
import { ClassicSpinner } from "react-spinners-kit";
import { notifyError, notifySuccess } from "../../Common/CommonFunction";

const ActivityManagement = () => {
  const [loading, setLoading] = useState(false);
  const [ActivityEditMenu, setActivityEditMenu] = useState(false);
  const [SaveToCloud, setSaveToCloud] = useState(false);
  const [data, setData] = useState([]);

  const [DisplayData, setDisplayData] = useState([]);
  const [Description, setDescription] = useState("");
  const [Description_Head, setDescription_Head] = useState("");
  const [Lectures, setLectures] = useState("");
  const [ModuleName, setModuleName] = useState("");
  const [TotalDurationInMinutes, setTotalDurationInMinutes] = useState("");
  const [ActivityResource, setActivityResource] = useState([]);

  // Tracks the module_name of the item currently being edited, captured
  // BEFORE the user is allowed to rename it in the form. Used to find and
  // replace that exact item in place, so editing never reorders the list.
  // Stays null while creating a brand-new activity.
  const [EditingOriginalModuleName, setEditingOriginalModuleName] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const { data } = location.state ? location.state : [];
    if (data) {
      setData(data);
      setDisplayData(data["modules"] ? data["modules"] : []);
    }
  }, []);

  const EraseDataFromState = () => {
    setDescription("");
    setDescription_Head("");
    setLectures("");
    setModuleName("");
    setTotalDurationInMinutes("");
    setActivityResource([]);
    setEditingOriginalModuleName(null);
  };

  const setDataToEditTab = (data) => {
    setDescription(data.description);
    setDescription_Head(data.description_head);
    setLectures(data.Lectures);
    setModuleName(data.module_name);
    setTotalDurationInMinutes(data.TotalDurationInMinutes);
    setActivityResource(data.resource);
    setEditingOriginalModuleName(data.module_name);
    setActivityEditMenu(true);
  };

  const columns = [
    {
      title: "Module Name",
      dataIndex: "module_name",
      sorter: (a, b) => a.module_name.length - b.module_name.length,
      render: (text, record) => (
        <Link onClick={() => setDataToEditTab(record)}>{text}</Link>
      ),
    },
    {
      title: "Description Head",
      dataIndex: "description_head",
      sorter: (a, b) => a.description_head.length - b.description_head.length,
    },
    {
      title: "Resource Count",
      dataIndex: "resource",
      render: (text) => <div>{text.length}</div>,
    },
    {
      title: "Duration in Minutes",
      dataIndex: "TotalDurationInMinutes",
    },
    {
      title: "Activities",
      dataIndex: "module_name",
      render: (text, record) => (
        <div>
          <Link
            to="/codomo/admin/subactivitymanagement"
            state={{ fulldata: data, data: record }}
          >
            <iconify-icon
              icon="icon-park-outline:activity-source"
              style={{ color: "blue", fontSize: "1.8em", marginLeft: "20px" }}
            ></iconify-icon>
          </Link>
          <iconify-icon
            icon="line-md:remove"
            style={{ color: "red", fontSize: "1.8em", marginLeft: "20px" }}
            onClick={() => RemoveItemFromdata(text)}
          />
        </div>
      ),
    },
  ];

  const UpdateDataInState = () => {
    // Convert numeric fields to strings for validation
    const trimmedModuleName = ModuleName.trim();
    const trimmedDescriptionHead = Description_Head.trim();
    const trimmedDescription = Description.trim();
    const trimmedLectures = Lectures.toString().trim();
    const trimmedTotalDuration = TotalDurationInMinutes.toString().trim();

    if (
      !trimmedModuleName ||
      !trimmedDescriptionHead ||
      !trimmedDescription ||
      !trimmedLectures ||
      !trimmedTotalDuration
    ) {
      notifyError("Please fill all required fields before saving");
      return;
    }

    const temp = {
      module_name: trimmedModuleName,
      description_head: trimmedDescriptionHead,
      description: trimmedDescription,
      Lectures: Number(trimmedLectures),
      TotalDurationInMinutes: Number(trimmedTotalDuration),
      resource: ActivityResource,
    };

    let updatedDisplayData;

    if (EditingOriginalModuleName) {
      // Editing an existing item: replace it in place (by its ORIGINAL
      // name, even if the name field was changed) so its position in the
      // list never moves. This is the fix for the "jumps to the end" bug.
      const nameTakenByAnotherItem = DisplayData.some(
        (item) =>
          item.module_name === trimmedModuleName &&
          item.module_name !== EditingOriginalModuleName
      );
      if (nameTakenByAnotherItem) {
        notifyError("Another activity already uses this module name");
        return;
      }

      updatedDisplayData = DisplayData.map((item) =>
        item.module_name === EditingOriginalModuleName ? temp : item
      );
    } else {
      // Creating a brand-new item: append it at the end, same as before.
      const alreadyExists = DisplayData.some(
        (item) => item.module_name === trimmedModuleName
      );
      if (alreadyExists) {
        notifyError("An activity with this module name already exists");
        return;
      }
      updatedDisplayData = [...DisplayData, temp];
    }

    setDisplayData(updatedDisplayData);
    setActivityEditMenu(false);
    setSaveToCloud(true);
    setEditingOriginalModuleName(null);
  };

  const RemoveItemFromdata = (moduleNameOfItem) => {
    const Repetation = DisplayData.filter(
      (item) => item.module_name !== moduleNameOfItem
    );
    setDisplayData(Repetation);
    setSaveToCloud(true);
  };

  const UpdateUserDataToCloud = async () => {
    setLoading(true);
    let temp = data;
    temp["modules"] = DisplayData;

    const responsedata = await ConstructorEventPost(UpdateCourseDetails, temp);
    if (responsedata === "course_updated") {
      notifySuccess("Activity Updated");
      navigate("/codomo/admin/activitymanagement");
    } else {
      notifyError("Something Gone Wrong");
    }
    setLoading(false);
  };

  if (data?.course_id) {
    localStorage.setItem("course_id_1", data.course_id);
  }

  return (
    <>
      <Header />
      {loading ? (
        <div className="spinner">
          <div className="spinner-wrapper">
            <ClassicSpinner size={50} color="black" loading={loading} />
          </div>
        </div>
      ) : (
        <div className="nav-tab-wrapper tabs section-padding">
          <div className="container">
            <div className="grid grid-cols-12 gap-[30px]">
              <div className="xl:col-span-5 lg:col-span-6 col-span-12">
                <div className="mini-title">
                  Activity Management
                  {SaveToCloud && (
                    <div
                      className="small-btn-saveDataToCloud ml-4"
                      onClick={UpdateUserDataToCloud}
                    >
                      <iconify-icon
                        icon="tabler:cloud-up"
                        style={{ fontSize: "1em" }}
                      />
                      Save Changes To Cloud
                    </div>
                  )}
                </div>
                <div
                  className="small-btn mt-4"
                  onClick={() => (EraseDataFromState(), setActivityEditMenu(true))}
                >
                  <iconify-icon
                    icon="typcn:plus"
                    style={{ fontSize: "1em" }}
                  ></iconify-icon>{" "}
                  Create New Activity
                </div>

                {ActivityEditMenu && (
                  <div className="bg-white shadow-box7 p-8 rounded-md mt-8">
                    <div className="input-container mt-8">
                      <input
                        type="text"
                        className="from-control"
                        value={ModuleName}
                        onChange={(e) => setModuleName(e.target.value)}
                      />
                      <span
                        className={`input-placeholder ${
                          ModuleName && "active"
                        }`}
                      >
                        Module Name *
                      </span>
                    </div>
                    <div className="input-container mt-8">
                      <input
                        type="text"
                        className="from-control"
                        value={Description_Head}
                        onChange={(e) => setDescription_Head(e.target.value)}
                      />
                      <span
                        className={`input-placeholder ${
                          Description_Head && "active"
                        }`}
                      >
                        Description Head *
                      </span>
                    </div>
                    <div className="input-container mt-8">
                      <input
                        type="text"
                        className="from-control"
                        value={Description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                      <span
                        className={`input-placeholder ${Description && "active"}`}
                      >
                        Description *
                      </span>
                    </div>
                    <div className="input-container mt-8">
                      <input
                        type="number"
                        className="from-control"
                        value={TotalDurationInMinutes}
                        onChange={(e) => setTotalDurationInMinutes(e.target.value)}
                      />
                      <span
                        className={`input-placeholder ${
                          TotalDurationInMinutes && "active"
                        }`}
                      >
                        Total Duration In Minutes *
                      </span>
                    </div>
                    <div className="input-container mt-8">
                      <input
                        type="number"
                        className="from-control"
                        value={Lectures}
                        onChange={(e) => setLectures(e.target.value)}
                      />
                      <span
                        className={`input-placeholder ${Lectures && "active"}`}
                      >
                        Lectures *
                      </span>
                    </div>
                    <button
                      className="btn btn-black mt-4 mr-4"
                      onClick={UpdateDataInState}
                      disabled={
                        !ModuleName.trim() ||
                        !Description_Head.trim() ||
                        !Description.trim() ||
                        !TotalDurationInMinutes.toString().trim() ||
                        !Lectures.toString().trim()
                      }
                      style={{
                        opacity:
                          !ModuleName.trim() ||
                          !Description_Head.trim() ||
                          !Description.trim() ||
                          !TotalDurationInMinutes.toString().trim() ||
                          !Lectures.toString().trim()
                            ? 0.5
                            : 1,
                        cursor:
                          !ModuleName.trim() ||
                          !Description_Head.trim() ||
                          !Description.trim() ||
                          !TotalDurationInMinutes.toString().trim() ||
                          !Lectures.toString().trim()
                            ? "not-allowed"
                            : "pointer",
                      }}
                    >
                      Save
                    </button>
                  </div>
                )}
              </div>

              <div className="xl:col-span-7 lg:col-span-6 col-span-12">
                <div className="bg-white shadow-box7 p-8 rounded-md">
                  <div className="from-control mb-4">
                    Total Activity : {DisplayData && DisplayData.length}
                  </div>
                  <Table
                    columns={columns}
                    dataSource={DisplayData}
                    pagination={DisplayData.length > 9}
                    rowKey={(record) => record.module_name}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ActivityManagement;